export default __webpack_public_path__ + "static/media/pomegranate.1debb750.png";